import { render, staticRenderFns } from "./TabelaInfosPublicasBndesPf.vue?vue&type=template&id=46f53bc6&lang=pug"
import script from "./TabelaInfosPublicasBndesPf.vue?vue&type=script&lang=js"
export * from "./TabelaInfosPublicasBndesPf.vue?vue&type=script&lang=js"
import style0 from "./TabelaInfosPublicasBndesPf.vue?vue&type=style&index=0&id=46f53bc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports